/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CompanyForm from '../model/CompanyForm';
import InlineResponse200 from '../model/InlineResponse200';
import InlineResponse400 from '../model/InlineResponse400';
import InlineResponse404 from '../model/InlineResponse404';

/**
* CompanyForm service.
* @module api/CompanyFormApi
* @version 1.0.0
*/
export default class CompanyFormApi {

    /**
    * Constructs a new CompanyFormApi. 
    * @alias module:api/CompanyFormApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Confirmar formulario de empresa
     * Marca como definitivo (is_template = false), genera PDF, lo sube a GCS, crea el DocumentDraft y actualiza el contrato. 
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CompanyForm} and HTTP response
     */
    apiV1MyaccountGiveformConfirmContractIdPostWithHttpInfo(contractId) {
      let postBody = null;
      // verify the required parameter 'contractId' is set
      if (contractId === undefined || contractId === null) {
        throw new Error("Missing the required parameter 'contractId' when calling apiV1MyaccountGiveformConfirmContractIdPost");
      }

      let pathParams = {
        'contract_id': contractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CompanyForm;
      return this.apiClient.callApi(
        '/api/v1/myaccount/giveform/confirm/{contract_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Confirmar formulario de empresa
     * Marca como definitivo (is_template = false), genera PDF, lo sube a GCS, crea el DocumentDraft y actualiza el contrato. 
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CompanyForm}
     */
    apiV1MyaccountGiveformConfirmContractIdPost(contractId) {
      return this.apiV1MyaccountGiveformConfirmContractIdPostWithHttpInfo(contractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Obtener formulario de datos de empresa
     * Devuelve el JSON guardado del formulario, o un esqueleto con campos vacíos si no existe.
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CompanyForm} and HTTP response
     */
    apiV1MyaccountGiveformContractIdGetWithHttpInfo(contractId) {
      let postBody = null;
      // verify the required parameter 'contractId' is set
      if (contractId === undefined || contractId === null) {
        throw new Error("Missing the required parameter 'contractId' when calling apiV1MyaccountGiveformContractIdGet");
      }

      let pathParams = {
        'contract_id': contractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CompanyForm;
      return this.apiClient.callApi(
        '/api/v1/myaccount/giveform/{contract_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Obtener formulario de datos de empresa
     * Devuelve el JSON guardado del formulario, o un esqueleto con campos vacíos si no existe.
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CompanyForm}
     */
    apiV1MyaccountGiveformContractIdGet(contractId) {
      return this.apiV1MyaccountGiveformContractIdGetWithHttpInfo(contractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Crear o actualizar formulario de empresa
     * Guarda el formulario. Todos los campos obligatorios se validan con trim(). Al menos un día laborable (monday–friday) debe tener contenido. 
     * @param {Number} contractId ID del contrato
     * @param {module:model/CompanyForm} companyForm 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse200} and HTTP response
     */
    apiV1MyaccountGiveformContractIdPostWithHttpInfo(contractId, companyForm) {
      let postBody = companyForm;
      // verify the required parameter 'contractId' is set
      if (contractId === undefined || contractId === null) {
        throw new Error("Missing the required parameter 'contractId' when calling apiV1MyaccountGiveformContractIdPost");
      }
      // verify the required parameter 'companyForm' is set
      if (companyForm === undefined || companyForm === null) {
        throw new Error("Missing the required parameter 'companyForm' when calling apiV1MyaccountGiveformContractIdPost");
      }

      let pathParams = {
        'contract_id': contractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/api/v1/myaccount/giveform/{contract_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Crear o actualizar formulario de empresa
     * Guarda el formulario. Todos los campos obligatorios se validan con trim(). Al menos un día laborable (monday–friday) debe tener contenido. 
     * @param {Number} contractId ID del contrato
     * @param {module:model/CompanyForm} companyForm 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse200}
     */
    apiV1MyaccountGiveformContractIdPost(contractId, companyForm) {
      return this.apiV1MyaccountGiveformContractIdPostWithHttpInfo(contractId, companyForm)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
